export enum CostType {
    "Essence voiture personnelle" = "0",
    "Essence camion société" = "1",
    "Restauration" = "2",
    "hôtel" = "3",
    "frais divers" = "4",
}
